<template>
  <div class="text--primary">
    <v-row>
      <v-col cols="12">
        <div v-if="loading">
          <px-circular-loading/>
        </div>
        <div v-else>
          <px-lista-notificacoes :notificacoes="configNotificacoes"
                                 @update="onUpdate"/>
        </div>
      </v-col>
    </v-row>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ListaNotificacoes from '../components/ListaNotificacoes.vue';
import NotificacaoService from '../service/config-notificacao-service';
import { buildNotificacoes } from '../utils/notificacao-utils';

export default {
  data() {
    return {
      loading: false,
      configNotificacoes: [],
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  methods: {
    getNotificacoes() {
      this.loading = true;

      NotificacaoService.getNotificacoesUserList({
        query: `usuario.id = ${this.user.id}`,
      })
        .then((response) => {
          this.configNotificacoes = buildNotificacoes(response.data, this.user, 'user');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      this.getNotificacoes();
    },
  },
  created() {
    this.getNotificacoes();
  },
  components: {
    pxListaNotificacoes: ListaNotificacoes,
  },
};
</script>
